import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"

import "./filtrosRapidos.css"

/*
	Barra de filtros rapidos, compartida.

	Nacio en Asistencias, donde las listas salian con los 1 135 horarios del
	plantel revueltos —acabados, sin alumnos y de cualquier dia— detras de cuatro
	desplegables de 12px. Ahi se resolvio abriendo con lo que de verdad se
	consulta y dejando cada condicion a un toque de distancia.

	Aqui esa idea se saca a un componente para que Horarios, Calendario y lo que
	venga se vean y se manejen igual. Los chips los define quien lo usa: el
	componente solo sabe de encendido y apagado. (Esteban, 2026-09-16)
*/

export type Interruptores = {[llave : string] : boolean}

export interface Chip
{
	llave  : string
	texto  : string
	/** Lo que sale al dejar el cursor encima; explica que hace el chip. */
	ayuda? : string
}

interface Props
{
	chips       : Chip[]
	valores     : Interruptores
	onCambio    : (nuevos : Interruptores) => void
	/** Estado al que vuelve el boton de reinicio. Sin esto el boton no sale. */
	porOmision? : Interruptores
	/** Texto del boton de reinicio; por omision, "Volver a lo de hoy". */
	textoReinicio? : string

	busqueda    : string
	onBusqueda  : (valor : string) => void
	onBuscar    : () => void
	onLimpiar   : () => void
	marcador?   : string
	/** Para modulos que ya tienen su propia caja de busqueda arriba. */
	sinBuscador? : boolean

	idleLocked  : boolean
	/** Cuantos resultados hay. La palabra la pone quien lo usa. */
	cuenta?     : number
	nombreUno?  : string
	nombreVarios? : string

	panel?        : React.ReactNode
	panelAbierto? : boolean
	onPanel?      : () => void
}

const FiltrosRapidos = ({
	chips, valores, onCambio, porOmision, textoReinicio,
	busqueda, onBusqueda, onBuscar, onLimpiar, marcador, sinBuscador,
	idleLocked, cuenta, nombreUno, nombreVarios,
	panel, panelAbierto, onPanel
} : Props) =>
{
	const alternar = (llave : string) =>
		onCambio({...valores, [llave] : !valores[llave]})

	//Solo se ofrece volver al inicio cuando de verdad se movio algo.
	const enOmision = porOmision == null || Object
		.keys(porOmision)
		.every(llave => (valores[llave] === true) === (porOmision[llave] === true))

	return <div className="waFiltros">
		<div className="waFiltrosFila">
			{sinBuscador ? null :
			<div className="waBuscador">
				<FontAwesomeIcon icon={solid("magnifying-glass")} />
				<input
					type="search"
					value={busqueda}
					placeholder={marcador || "Buscar"}
					disabled={idleLocked}
					onChange={evento => onBusqueda(evento.target.value)}
					onKeyDown={evento => { if(evento.key === "Enter") onBuscar() }}
				/>
				{
					!busqueda ? null :
						<button type="button" onClick={onLimpiar} aria-label="Limpiar búsqueda">
							<FontAwesomeIcon icon={solid("xmark")} />
						</button>
				}
			</div>}

			<div className="waChips">
				{
					chips.map(unChip => <button
						key={unChip.llave}
						type="button"
						className={valores[unChip.llave] ? "waChipFiltro activo" : "waChipFiltro"}
						aria-pressed={valores[unChip.llave] === true}
						disabled={idleLocked}
						title={unChip.ayuda}
						onClick={() => alternar(unChip.llave)}
					>
						{valores[unChip.llave] ? <FontAwesomeIcon icon={solid("check")} /> : null}
						{unChip.texto}
					</button>)
				}

				{
					enOmision || porOmision == null ? null :
						<button
							type="button"
							className="waChipFiltro limpio"
							disabled={idleLocked}
							onClick={() => onCambio({...porOmision})}
						>
							{textoReinicio || "Volver a lo de hoy"}
						</button>
				}

				{
					!panel ? null :
						<button
							type="button"
							className={panelAbierto ? "waChipFiltro mas activo" : "waChipFiltro mas"}
							aria-expanded={panelAbierto}
							onClick={onPanel}
						>
							<FontAwesomeIcon icon={solid("sliders")} />
							Más filtros
						</button>
				}
			</div>

			{
				cuenta === undefined ? null :
					<span className="waCuenta">
						{cuenta === 1
							? "1 " + (nombreUno || "resultado")
							: cuenta + " " + (nombreVarios || "resultados")}
					</span>
			}
		</div>

		{
			!panelAbierto || !panel ? null : <div className="waFiltrosPanel">{panel}</div>
		}
	</div>
}

export default FiltrosRapidos
